<template>
	<el-dialog title="设置商品排序" :visible.sync="visible" width="900px" :before-close="closeCategoryDialog">
		<div>SPU：<el-input v-model="spuCodes" size="medium" placeholder="请输入SPU" style="width:200px;" @change="getProductList" /></div>
		<div v-if="kkProductIds.length" style="margin-top:20px">
			批量设置优先级：<el-input v-model="batchSort" type="number" size="medium" placeholder="输入数字" style="width:100px;margin-right:20px" />
			<el-button size="medium" @click="close">取 消</el-button>
			<el-button size="medium" type="primary" @click="confirm">确 定</el-button>
		</div>
		<el-table ref="multipleTable" :data="productData" v-loading="loading" height="500" @selection-change="handleSelectionChange" @sort-change="tableSortChange">
			<el-table-column type="selection" width="55" />
			<el-table-column label="图片">
				<template slot-scope="{row}">
					<el-popover placement="right" width="240" trigger="hover">
						<el-image :src="row.imgUrl" fit="cover" />
						<el-image slot="reference" :src="row.imgUrl" fit="cover" style="width:60px;height:60px;" />
					</el-popover>
				</template>
			</el-table-column>
			<el-table-column prop="spuCode" label="SPU" />
			<el-table-column prop="sort" label="排序优先级" sortable="custom">
				<template slot-scope="{row}">
					<el-input v-model="row.sort" type="number" size="medium" placeholder="输入数字" @blur="confirm('set', row)" />
				</template>
			</el-table-column>
			<el-table-column prop="price" label="价格" sortable="custom" />
			<el-table-column prop="stock" label="库存" sortable="custom" />
			<el-table-column prop="salesVolume" label="销量" sortable="custom" />
		</el-table>
		<el-pagination background :current-page="1" :page-size="parameter.pageSize" layout="prev, pager, next" :total="total" style="text-align:right;margin-top:10px" @current-change="handleCurrentChange" />
		<span slot="footer" class="dialog-footer">
			<el-button size="medium" @click="closeCategoryDialog">取 消</el-button>
			<el-button size="medium" type="primary" @click="confirmDialogVisible">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import API from '@/api'

export default {
  components: {
  },
  data() {
    return {
			visible: false,
			spuCodes: '',
			batchSort: '',
			kkProductIds: [],
			parameter: {
				pageNumber: 1, // 当前页
				pageSize: 20, // 每日显示条数
				sortName: undefined, // 排序字段：1-排序、2-价格、3-库存、4-销量
				sortType: undefined, // 排序的类型：asc升序 desc降序
				spuCodes: [],
				categoryId: ''
			},
			total: 0,
			productData: [],
			loading: false
    }
  },
  created() {
  },
  methods: {
		show(categoryId) {
			this.visible = true
			this.parameter.categoryId = categoryId
			this.getProductList()
		},
		close() {
      this.batchSort = undefined
      this.$refs.multipleTable.clearSelection();
    },
		confirm(type, row) {
      if (type !== 'set' && this.batchSort === '') {
        return
      }
      if (type === 'set' && row.sort === '') {
        return
      }
			API.categoryProductSortBatch({ kkProductIds: type === 'set' ? [row.kkProductId] : this.kkProductIds, sort: type === 'set' ? row.sort : this.batchSort }).then(res => {
				this.$message.success(res.message)
        if (type !== 'set') {
          this.batchSort = ''
          this.kkProductIds = []
        }
				this.getProductList()
			})
		},
		closeCategoryDialog() {
			this.spuCodes = ''
			this.batchSort = ''
			this.kkProductIds = []
			this.visible = false
		},
		confirmDialogVisible() {},
		// 当表格复选框选择项发生变化时会触发该事件
    handleSelectionChange(selection) {
      this.kkProductIds = selection.map((item) => item.kkProductId)
    },
		// 当表格的排序条件发生变化的时候会触发该事件
    tableSortChange({ prop, order }) {
      if (order === 'ascending') { // 升序
        if (prop === 'salesVolume') { // 销量
          this.parameter.sortName = 4
        } else if (prop === 'price') { // 价格
          this.parameter.sortName = 2
        } else if (prop === 'stock') { // 库存
          this.parameter.sortName = 3
        } else if (prop === 'sort') { // 排序
          this.parameter.sortName = 1
        }
        this.parameter.sortType = 'asc'
      } else if (order === 'descending') { // 降序
        if (prop === 'salesVolume') { // 销量
          this.parameter.sortName = 4
        } else if (prop === 'price') { // 价格
          this.parameter.sortName = 2
        } else if (prop === 'stock') { // 库存
          this.parameter.sortName = 3
        } else if (prop === 'sort') { // 排序
          this.parameter.sortName = 1
        }
        this.parameter.sortType = 'desc'
      } else { // null表示还原为原始顺序
        this.parameter.sortType = undefined
        this.parameter.sortName = undefined
      }
      this.getProductList()
    },
		// 通过品类id获取下面的产品
		getProductList() {
			this.loading = true
			this.parameter.spuCodes = this.spuCodes ? [this.spuCodes] : []
			API.productByCategoryId(this.parameter).then(({ data }) => {
				this.productData = data.list
				this.total = data.total
			}).finally(() => {
				this.loading = false
			})
		},
		// 当前页发生改变时触发的回调
    handleCurrentChange(value) {
      this.parameter.pageNumber = value
      this.getProductList()
    },
  }
}
</script>

<style lang="scss" scoped>
</style>